import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Typography, Tabs, Tab, Box } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';

export interface IState {
    curation_stats: any;
    show: boolean;
    selectedBarcode: any;
    selectedProfiler: any;
    selectedRows: any[];
    toggleCleared: boolean;

    children?: React.ReactNode;
    tabIndex?: number;
    tabValue: number;
}

class SettingsHeader extends React.Component<RouteComponentProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & WithTranslation) {
        super(props);
        let current_path = this.props.location.pathname.split('/');
        let activeTab = 0;
        if(current_path[2] == 'constants'){
            activeTab = 0;
        } else if(current_path[2] == 'sms-template'){
            activeTab = 1;
        } else if(current_path[2] == 'acceptance-stat'){
            activeTab = 2;
        }
        this.state = {
            curation_stats: {
                "barcodes_count": 0,
                "assigned_barcodes_count": 0,
                "inprogress_barcodes_count": 0,
                "curated_barcodes_count": 0
            },
            show: false,
            selectedBarcode: {},
            selectedProfiler: "",
            selectedRows: [],
            toggleCleared: false,
            tabValue: activeTab,
        }
    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const handleChange = (event: React.SyntheticEvent, newValue: number) => {
            if (newValue == 0) {
                this.props.history.push('/settings/constants')
            } else if (newValue == 1) {
                this.props.history.push('/settings/sms-template')
            } else if (newValue == 2) {
                this.props.history.push('/settings/acceptance-stat')
            }
            console.log(newValue);
        };
        return (
            <div>
                <Typography variant="h4" className='page-title'>{t("Settings")}</Typography>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={this.state.tabValue} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Constants" />
                        <Tab label="SMS Template" />
                        <Tab label="Acceptance Stats"/>
                    </Tabs>
                </Box>
            </div>
        )
    }
}

export default withRouter(withTranslation()(SettingsHeader))